module.exports = __webpack_public_path__ + "assets/img/id-energias-logo-small.1f3690a9.webp";